import type { Service } from "../types/serviceTypes";

export function compareServiceOrder(a: Service, b: Service): number {
  return a.sortOrder - b.sortOrder || a.id.localeCompare(b.id);
}
